export const SUBSCRIPTIONS = {
  HID_MOBILE: 'controller_hidmobile',
  SALTO: 'controller_salto',
  HID_APPLE_WALLET: 'controller_hid_apple_wallet',
  WAVELYNX: 'controller_wavelynx',
  DIGITAL_CRED: 'controller_digital_cred',
  VIRTUAL_CRED: 'controller_virtual_cred',
  STAND: 'controller_stand',
  ADMISSION: 'controller_admission',
  HID_CONNECT: 'controller_hid_connect',
  API: 'controller_bridge',
  CONTROLLER: 'controller',
  PRESS: 'controller_press',
  SECURE: 'controller_secure',
  IDENT: 'controller_ident'
} as const;